/* eslint-disable @typescript-eslint/naming-convention */
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AuthenticationService } from "../authentication/authentication.service";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthenticationService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const url = new URL(request.url);

    if (!url.hostname.endsWith(".amazonaws.com")) {
      const currentUser = this.authenticationService.currentUserInfo;

      if (currentUser && currentUser.accessToken) {
        request = this.addToken(request, currentUser.accessToken);
      }
    }

    return next.handle(request);
  }

  private addToken(request: HttpRequest<unknown>, token: string): HttpRequest<unknown> {
    if (request.headers.keys().includes("x-skip-auth")) {
      return request.clone({ headers: request.headers.delete("x-skip-auth") });
    }
    return request.clone({
      setHeaders: {
        authorization: `Bearer ${token}`,
        "Cache-Control": "no-cache, no-store",
        Pragma: "no-cache",
      },
    });
  }
}
